import { render, staticRenderFns } from "./UnauthorizedLayout.vue?vue&type=template&id=5963d6ee"
import script from "./UnauthorizedLayout.vue?vue&type=script&lang=js"
export * from "./UnauthorizedLayout.vue?vue&type=script&lang=js"
import style0 from "./UnauthorizedLayout.vue?vue&type=style&index=0&id=5963d6ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports